import { apiService } from "./api";
import {
    PaymentSearchParams,
    PaymentSearchResponse,
    PaymentSummaryResponse,
} from "../types/paymentsOverview";

class PaymentsOverviewService {
    async search(params: PaymentSearchParams): Promise<PaymentSearchResponse> {
        return apiService.get<PaymentSearchResponse>("/payments/overview/search", { params });
    }

    async getSummary(params: PaymentSearchParams): Promise<PaymentSummaryResponse> {
        return apiService.get<PaymentSummaryResponse>("/payments/overview/summary", { params });
    }
}

export const paymentsOverviewService = new PaymentsOverviewService();
